import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { JsonToExcel } from 'react-json-to-excel';


export const ExcelExportUsersButton = (props) => {
    const { t } = useTranslation();
    const [userExcelData, setUserExcelData] = useState(null);
    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    const handleClick = async () => {
        const dataToExport = props.ExcelExportUsersData;
        const tmpExcelData = dataToExport.map((user) => ({
            [t('Mail')]: user.email,
            [t('Nom')]: user.firstName,
            [t('Prénom')]: user.lastName,
            [t('Téléphone')]: user.phoneNumber,
            [t('Active')]: user.activated,
            [t('Langue')]: user.isoLanguageCode,
            [t('Rôle')]: (user.role).replace("ROLE_", "").replace("_", " ").toLowerCase(),
            [t('Site')]: user.account,
        }));
        setUserExcelData(tmpExcelData);
        await sleep(500);
        document.querySelector('.download-button').click();
    };

    return (
        <div className="container-excel img-container">
            <div className={props.ExcelExportUsersData.length > 0 ? 'icon-btn-test-3' : ''}>
                <div className="">
                    <img
                        src="/Images/icon-excel.png"
                        onClick={handleClick}
                        className="App-logo-excel"
                        alt="logo"
                    />
                </div>
            </div>
            <div className="json-to-excel-container">
                <JsonToExcel
                    data={userExcelData}
                    fileName="Base_de_contact"
                    fields={[
                        { label: 'Mail', value: 'Mail' },
                        { label: 'Prénom', value: 'Prénom' },
                        { label: 'Nom', value: 'Nom' },
                        { label: 'Téléphone', value: 'Téléphone' },
                        { label: 'Active', value: 'Active' },
                        { label: 'Langue', value: 'Langue' },
                        { label: 'Rôle', value: 'Rôle' },
                        { label: 'Site', value: 'Site' },
                    ]}
                    buttonText="Export to Excel"
                    btnColor="white"
                    btnClassName="download-button"
                />
            </div>
        </div>
    );
};
